import { createStyles, makeStyles, Tab, Tabs, Theme, Paper } from "@material-ui/core";
import React, { FC } from 'react';
import { Link, useLocation } from 'react-router-dom';

export interface ITabConfig {
    name: string
    link: string
    id: string
    isActive?: boolean,
    matcher?: RegExp
}

export interface HeaderNavLinksProps {
    tabsConfig?: Array<ITabConfig>
    appendLinkInUrl?: boolean
    baseUrl: string
}

//TODO: Use matcher for matching current tab on priority
const getCurrentTab = (currentLocation: string, baseUrl: string, tabsConfig: Array<ITabConfig>) => {
    const sanitizedUrl = currentLocation.replace(baseUrl, '').replace(/\//g, '');
    const matchedIndex = tabsConfig.findIndex((tabConfig: ITabConfig) => {
        if (tabConfig.link === sanitizedUrl)
            return true;
        return (tabConfig.matcher && new RegExp(tabConfig.matcher).test(sanitizedUrl));
    });
    if (matchedIndex === -1)
        return 0;
    return matchedIndex;
}

const HeaderNavLinks: FC<HeaderNavLinksProps> = (props) => {
    const { tabsConfig = [], appendLinkInUrl = true, baseUrl } = props;
    const location = useLocation();
    const tabValue = getCurrentTab(location.pathname, baseUrl, tabsConfig);
    const classes = useStyles();
    return (
        <Paper className={classes.root} >
            <Tabs
                value={tabValue}
                onChange={() => { }}
                indicatorColor="primary"
                textColor="primary"
                classes={{
                    indicator: classes.tabsIndicator,
                }}
            >
                {
                    tabsConfig.map((tab, i) => {
                        return (
                            <Tab key={tab.id} label={tab.name} component={Link}
                                to={(appendLinkInUrl) ? `${props.baseUrl}/${tab.link}` : `/${tab.link}`}
                                classes={{
                                    root: classes.tabRoot
                                }}
                            />
                        )
                    })
                }
            </Tabs>
        </Paper>
    )
};

const useStyles = makeStyles((theme: Theme) => {
    const { palette: { background } } = theme;
    return (createStyles({
        root: {
            width: '100%',
            display: 'flex',
            justifyContent: 'center',
            backgroundColor: background['default'],
            height: 60,
            boxShadow: '0px 1px 3px #00000029'
        },
        tabRoot: {
            minWidth: 0,
            textTransform: 'inherit',
            fontWeight: 'bold',
            padding: 0,
            margin: '6px 12px',
            marginBottom: 0,
            paddingBottom: 6
        },
        tabsIndicator: {
            height: 4
        }
    }))
});

export default HeaderNavLinks;